<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>车辆外观检查管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="10">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px " @clear="getwaiguanList" @change="getwaiguanList">
                        <el-button slot="append" icon="el-icon-search" @click="getwaiguanList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="get_waiguan_edit" v-if="false">添加车辆外观检查</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="waiguanList" style="width: 100%" border stripe>
                        <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
                        <el-table-column prop="bianhao" label=" 编号" width="200"></el-table-column>
                        <el-table-column prop="waiguan_memo" label="外观"></el-table-column>
                        <el-table-column prop="paizhao" label="牌照"></el-table-column>
                        <el-table-column label="型号">
                            <template v-slot="scope">
                                <div>
                                    {{ scope.row.chexing01 }}:{{ scope.row.chexing02 }}:{{ scope.row.chexing03 }}:{{ scope.row.chexing04 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template v-slot="scope">
                                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="检查单" placement="top" :enterable="false">
                                    <el-button type="primary" icon="el-icon-s-grid" @click="showQueryDialog(scope.row.uid)"
                                        circle size="mini"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                        @click="deleteForm(scope.row.uid)"></el-button>
                                </el-tooltip>
                                <!-- <el-tooltip class="item" effect="dark" content="设置为白名单" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-coordinate" circle size="mini"å
                    @click="baiMingdan(scope.row.uid,scope.row.waiguan_flag_baiMingdan)"></el-button>
                </el-tooltip> -->
                                <el-tooltip class="item" effect="dark" content="车辆外观检查回访" placement="top" :enterable="false"
                                    style="display: none;">
                                    <el-button type="success" icon="el-icon-orange"
                                        @click="showHuifangDialog(scope.row.uid)" circle size="mini"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>

            <!-- 添加车辆外观检查部分 -->
            <!-- 管理调用 -->
            <el-dialog title="编辑车辆外观检查" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
                <waiguanAdd ref="waiguanAdd" @getWaiguanNewUid="getWaiguanNewUid" @getWaiguanclose="getWaiguanclose" :diaoyongType="1" :key="datekey"
                    :editUid="editUid" :caozuoType="caozuoType" >
                </waiguanAdd>
            </el-dialog>
            <el-dialog title="车辆检查单" :visible.sync="jianceDialogVisible" width="50%"  >
                <jianchadan ref="waiguanAdd" @closeJianchadan="closeJianchadan"  :diaoyongType="1" :key="datekey"
                    :editUid="editUid" :caozuoType="caozuoType" >
                </jianchadan>
            </el-dialog>
            <el-dialog title="车辆外观查看" :visible.sync="cheliangDialogVisible" width="50%"  >
                <cheliang ref="cheliang" @getWaiguanInfo="getWaiguanInfo"   >
                </cheliang>
            </el-dialog>

        </el-card>
    </div>
</template>
<script>
import waiguanAdd from './module/waiguan_add.vue'
import jianchadan from './module/jianchadan.vue'
import cheliang from './cheliang.vue'
import { checkMobileTest, checkSfzId } from './config/validator';
import { ref } from 'vue';
export default {
    components: {
        waiguanAdd: waiguanAdd,
        cheliang: cheliang,
        jianchadan: jianchadan
    },
    data() {
        return {
            datekey: Date.now(),
            jianceDialogVisible: false,
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'waiguan_list',
                query: '',
                pageNum: 1,
                pageSize: 10,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            add_isDisable: false,
            waiguanList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            cheliangDialogVisible: false,

            // 用于设置回访页面滑块值
            //  添加表单数据项
            huifangForm: {
                C_type: 'huifang_add',
                huifang_waiguan_uid: 0,
                huifang_title: '',
                hufiang_memo: '',
                huifang_genjin: 1,
                huifang_switch: true
            },
            caozuoType: 0, // 操作类型 1 是添加 2是删除
            editUid: 0, // 修改uid
            addForm: {
                C_type: 'waiguan_add',
                uid: 0,
                waiguan_bianhao: '',
                waiguan_memo: ''
            },
            // 用于修改数据绑定
            editForm: {},
            // 表单规则项
            addFormRules: {
                // waiguan_name: [
                //     { required: true, message: '请输入车辆外观检查名称', trigger: 'blur' },
                //     { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                // ],

                waiguan_mob: [
                    {
                        validator: checkMobileTest.bind(
                            this.addForm && this.addForm.waiguan_mob
                        )
                    }
                ],
                waiguan_sfz_bianhao: [
                    {
                        validator: checkSfzId.bind(
                            this.addForm && this.addForm.waiguan_sfz_bianhao
                        )
                    }
                ]
            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getwaiguanList()
    },

    methods: {
      
        getWaiguanclose() {
            this.addDialogVisible = false  
        },
        getWaiguanNewUid() {
            this.getwaiguanList() 
            this.addDialogVisible = false
        },
        closeJianchadan() {
            this.jianceDialogVisible = false
        },
        getWaiguanInfo() {
            this.cheliangDialogVisible = false 
        },
        async get_waiguan_edit() {
          // this.$router.push('/shigong/cheliang');
             this.cheliangDialogVisible = true; // 要先打开才能调用
            // 通过更改组件的key 值，强制组件进行实时更新，每次出发create 函数
            this.datekey = Date.now()
            this.editUid = 0
            this.caozuoType = 1
            // 
        },
        async getwaiguanList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data)[0].dataList)
            this.waiguanList = JSON.parse(res.data)[0].dataList
            if (!this.waiguanList) return;
            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getwaiguanList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getwaiguanList();
        },
        showEditDialog(uid) {
           //  this.waiguanInfo(uid);
            this.editUid = uid // 写uid
            this.caozuoType = 2
            this.datekey = Date.now() // 强制更新
            this.addDialogVisible = true;
        },
        showQueryDialog(uid) {
           //  this.waiguanInfo(uid);
            this.editUid = uid // 写uid
            this.caozuoType = 2
            this.datekey = Date.now() // 强制更新
            this.jianceDialogVisible = true;
        },
        addDoalogClosed() {
            this.$refs.waiguanAdd.resetForm();
        },
        huifangDoalogClosed() {
            this.$refs.huifangFormRef.resetFields();
        },
        showHuifangDialog(uid) {
            this.huifangDialogVisible = true;
            this.waiguanInfo(uid);
        },
        async Info(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'waiguan_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.editForm = JSON.parse(res.data)[0].data[0];
            this.huifangForm.huifang_waiguan_uid = JSON.parse(res.data)[0].data[0].uid;
        },

        async deleteForm(waiguanUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'waiguan_del',
                C_data1: waiguanUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getwaiguanList();
        },

        // 设置白名单
        async baiMingdan(waiguanUid, baiMingdanFlag) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            var flag = 0
            if (baiMingdanFlag) flag = 0
            else flag = 1
            const comfirmResult = await this.$confirm(
                '确定要设置为白名单吗, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消');

            const { data: res } = await this.$http.post('api', {
                C_type: 'waiguan_baiMingdan',
                waiguanUid: waiguanUid,
                baiMingdanFlag: flag
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('设置失败');
                return;
            }
            this.$message.success('设置成功');
            this.getwaiguanList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
